import apiClient from "./api";

export interface ProductReportItem {
  id: number;
  SKU: string;
  Product_Name: string;
  Category: string;
  Brand: string;
  Type?: number;
  Qty: number; // Stock quantity
  Price: number;
  Total_Ordered: number; // Total Sales (quantity)
  Revenue: number; // Grand Total
}

export interface ProductReportResponse {
  current_page: number;
  data: ProductReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface InventoryReportItem {
  id: number;
  sku: string;
  product_name: string;
  category_name: string;
  brand_name: string;
  unit: string;
  type: number;
  cost: number;
  price: number;
  instock_qty: number;
  qty_alert: number;
}

export interface InventoryReportResponse {
  current_page: number;
  data: InventoryReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface ProductQuantityAlertReportItem {
  id: number;
  SKU: string;
  product_name: string;
  category_name?: string;
  warehouse_name: string;
  quantity: number;
  stock_alert: number;
}

export interface ProductQuantityAlertReportResponse {
  current_page: number;
  data: ProductQuantityAlertReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface WarehouseSaleReportItem {
  sale_id: number;
  created_at: string;
  reference_no: string;
  customer_name: string;
  quantity: number;
  price: number;
  status: string;
  subtotal: number;
  invoice_total: number;
  paid: number;
}

export interface WarehouseSaleReportResponse {
  current_page: number;
  data: WarehouseSaleReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface WarehousePurchaseReportItem {
  purchase_id: number;
  created_at: string;
  reference_no: string;
  supplier_name: string;
  quantity: number;
  price: number;
  status: string;
  invoice_total: number;
  paid: number;
  payment_status: string;
}

export interface WarehousePurchaseReportResponse {
  current_page: number;
  data: WarehousePurchaseReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface WarehouseQuotationReportItem {
  quote_id: number;
  created_at: string;
  reference_no: string;
  customer_name: string;
  quantity: number;
  price: number;
  status: string;
  invoice_total: number;
}

export interface WarehouseQuotationReportResponse {
  current_page: number;
  data: WarehouseQuotationReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface WarehouseExpenseReportItem {
  expense_id: number;
  created_at: string;
  reference_no: string;
  category_name: string;
  expense_name: string;
  amount: number;
  status: string | number;
  description?: string;
}

export interface WarehouseExpenseReportResponse {
  current_page: number;
  data: WarehouseExpenseReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface PurchasePaymentReportItem {
  payment_id: number;
  created_at: string;
  payment_ref: string;
  purchase_ref: string;
  supplier_name: string;
  payment_method: string;
  paid_by: string;
  amount: number;
  note: string;
}

export interface SalesPaymentReportItem {
  payment_id: number;
  created_at: string;
  payment_ref: string;
  sale_ref: string;
  customer_name: string;
  payment_method: string;
  paid_by: string;
  amount: number;
  note?: string;
}

export interface PurchasePaymentReportResponse {
  current_page: number;
  data: PurchasePaymentReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface SalesPaymentReportResponse {
  current_page: number;
  data: SalesPaymentReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface SalesReportItem {
  sale_id: number;
  created_at: string;
  reference_no: string;
  customer_name: string;
  quantity: number;
  status: string;
  invoice_total: number;
  paid: number;
  payment_status: string;
}

export interface SalesReportResponse {
  current_page: number;
  data: SalesReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface SalesReturnReportItem {
  return_id: number;
  created_at: string;
  return_ref: string;
  reference_no: string;
  customer_name: string;
  warehouse_name: string;
  quantity: number;
  status: string;
  invoice_total: number;
}

export interface SalesReturnReportResponse {
  current_page: number;
  data: SalesReturnReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface ProfitLossReportItem {
  month: string;
  sales: number;
  sales_returns: number;
  income: number;
  purchases: number;
  expenses: number;
  net_profit: number;
}

export interface ProfitLossReportResponse {
  status: boolean;
  year: number | string;
  warehouse_filtered?: boolean;
  includes_income?: boolean;
  totals?: {
    sales: number;
    sales_returns: number;
    income: number;
    purchases: number;
    expenses: number;
    net_profit: number;
  };
  data: ProfitLossReportItem[];
}

export interface SupplierReportItem {
  purchase_id: number;
  created_at: string;
  reference_no: string;
  supplier_code: string;
  supplier_name: string;
  quantity: number;
  invoice_total: number;
  paid: number;
  due: number;
  payment_method: string;
  status: string;
  payment_status: string;
}

export interface SupplierReportResponse {
  current_page: number;
  data: SupplierReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export interface CustomerReportItem {
  sale_id?: number;
  quote_id?: number;
  return_id?: number;
  created_at: string;
  reference_no: string;
  customer_name: string;
  status: string;
  invoice_total: number;
  paid: number;
  due: number;
}

export interface CustomerReportResponse {
  current_page: number;
  data: CustomerReportItem[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

export type UserReportItem = CustomerReportItem;
export interface UserReportResponse extends CustomerReportResponse {
  data: UserReportItem[];
}

const reportService = {
  async getProductReports(params?: { warehouse_id?: string | number; search_query?: string; per_page?: number | string; page?: number }): Promise<ProductReportResponse> {
    const response = await apiClient.get("/reports/products", { params });
    return response.data;
  },

  async getInventoryReports(params?: { warehouse_id?: string | number; search_query?: string; per_page?: number | string; page?: number }): Promise<InventoryReportResponse> {
    const response = await apiClient.get("/reports/inventory", { params });
    return response.data;
  },

  async getProductQuantityAlertReports(params?: {
    warehouse_id?: string | number;
    search_query?: string;
    per_page?: number | string;
    page?: number;
    limit?: number | string;
  }): Promise<ProductQuantityAlertReportResponse> {
    const response = await apiClient.get("/reports/productsqtyalert", { params });
    return response.data;
  },

  async getSalesReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    customer_id?: string | number;
    status?: string;
    pos?: number | string;
    page?: number;
    per_page?: number | string;
  }): Promise<SalesReportResponse> {
    const response = await apiClient.get("/reports/sales", { params });
    return response.data;
  },

  async exportSalesReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    customer_id?: string | number;
    status?: string;
    pos?: number | string;
  }) {
    const response = await apiClient.get("/reports/sales/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async getSalesReturnReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    customer_id?: string | number;
    status?: string;
    page?: number;
    per_page?: number | string;
  }): Promise<SalesReturnReportResponse> {
    const response = await apiClient.get("/reports/sales-return", { params });
    return response.data;
  },

  async exportSalesReturnReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    customer_id?: string | number;
    status?: string;
  }) {
    const response = await apiClient.get("/reports/sales-return/export", {
      params,
      responseType: "blob",
    });
    return response;
  },

  async getCustomerReports(params?: { 
    from_date?: string; 
    to_date?: string; 
    customer_id?: string | number; 
    warehouse_id?: string | number; 
    search_query?: string;
    report_type?: string; 
    page?: number; 
    per_page?: number | string; 
  }): Promise<CustomerReportResponse> {
    const response = await apiClient.get("/reports/customers", { params });
    return response.data;
  },
  async exportCustomerReports(params?: { 
    from_date?: string; 
    to_date?: string; 
    customer_id?: string | number; 
    warehouse_id?: string | number; 
    search_query?: string;
    report_type?: string; 
  }) {
    const response = await apiClient.get("/reports/customers/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async getUserReports(params?: { 
    from_date?: string; 
    to_date?: string; 
    user_id?: string | number; 
    warehouse_id?: string | number;
    search_query?: string;
    report_type?: string; 
    page?: number; 
    per_page?: number | string; 
  }): Promise<UserReportResponse> {
    const response = await apiClient.get("/reports/users", { params });
    return response.data;
  },

  async getProfitLossReport(params?: { year?: number | string; warehouse_id?: string | number }): Promise<ProfitLossReportResponse> {
    const response = await apiClient.get("/reports/profit-loss", { params });
    return response.data;
  },

  async getSupplierReports(params?: {
    warehouse_id?: string | number;
    supplier_id?: string | number;
    payment_method?: string;
    status?: string;
    from_date?: string;
    to_date?: string;
    search_query?: string;
    page?: number;
    per_page?: number | string;
  }): Promise<SupplierReportResponse> {
    const response = await apiClient.get("/reports/supplier", { params });
    return response.data;
  },

  async exportSupplierReports(params?: {
    warehouse_id?: string | number;
    supplier_id?: string | number;
    payment_method?: string;
    status?: string;
    from_date?: string;
    to_date?: string;
    search_query?: string;
  }) {
    const response = await apiClient.get("/reports/supplier/export", {
      params,
      responseType: "blob",
    });
    return response;
  },

  async exportProfitLossReport(params?: { year?: number | string; warehouse_id?: string | number }) {
    const response = await apiClient.get("/reports/profit-loss/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async getPurchaseReports(params?: {
    warehouse_id?: string | number;
    from_date?: string;
    to_date?: string;
    supplier_id?: string | number;
    status?: string;
    search_query?: string;
    page?: number;
    per_page?: number | string;
  }): Promise<WarehousePurchaseReportResponse> {
    const response = await apiClient.get("/reports/purchase", { params });
    return response.data;
  },

  async getPurchasePaymentReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    supplier_id?: string | number;
    method_id?: string | number;
    page?: number;
    per_page?: number | string;
  }): Promise<PurchasePaymentReportResponse> {
    const response = await apiClient.get("/reports/purchase-payments", { params });
    return response.data;
  },

  async exportPurchasePaymentReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    supplier_id?: string | number;
    method_id?: string | number;
  }) {
    const response = await apiClient.get("/reports/purchase-payments/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async getSalesPaymentReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    customer_id?: string | number;
    method_id?: string | number;
    pos?: number | string;
    page?: number;
    per_page?: number | string;
  }): Promise<SalesPaymentReportResponse> {
    const response = await apiClient.get("/reports/sales-payments", { params });
    return response.data;
  },

  async exportSalesPaymentReports(params?: {
    from_date?: string;
    to_date?: string;
    search_query?: string;
    warehouse_id?: string | number;
    customer_id?: string | number;
    method_id?: string | number;
    pos?: number | string;
  }) {
    const response = await apiClient.get("/reports/sales-payments/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async exportPurchaseReports(params?: {
    warehouse_id?: string | number;
    from_date?: string;
    to_date?: string;
    supplier_id?: string | number;
    status?: string;
    search_query?: string;
  }) {
    const response = await apiClient.get("/reports/purchase/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async getWarehouseSaleReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; page?: number; per_page?: number | string; search_query?: string }): Promise<WarehouseSaleReportResponse> {
    const response = await apiClient.get("/reports/warehouse/sale", { params });
    return response.data;
  },

  async getWarehousePurchaseReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; page?: number; per_page?: number | string; search_query?: string }): Promise<WarehousePurchaseReportResponse> {
    const response = await apiClient.get("/reports/warehouse/purchase", { params });
    return response.data;
  },
  async getWarehouseQuotationReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; page?: number; per_page?: number | string; search_query?: string }): Promise<WarehouseQuotationReportResponse> {
    const response = await apiClient.get("/reports/warehouse/quotation", { params });
    return response.data;
  },
  async getWarehouseExpenseReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; page?: number; per_page?: number | string; search_query?: string }): Promise<WarehouseExpenseReportResponse> {
    const response = await apiClient.get("/reports/warehouse/expense", { params });
    return response.data;
  },
  async exportInventoryReports(params?: { warehouse_id?: string; search_query?: string; selected_products?: (string | number)[] }) {
    const response = await apiClient.get("/reports/inventory/export", {
      params: {
        ...params,
        selected_products: params?.selected_products?.join(','),
      },
      responseType: 'blob', // Important for file download
    });
    return response;
  },

  async exportProductReports(params?: { warehouse_id?: string | number; search_query?: string; selected_products?: (string | number)[] }) {
    const response = await apiClient.get("/reports/products/export", {
      params: {
        ...params,
        selected_products: params?.selected_products?.join(','),
      },
      responseType: 'blob', // Important for file download
    });
    return response;
  },

  async exportWarehouseReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; search_query?: string }) {
    const response = await apiClient.get("/reports/warehouse/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async exportWarehousePurchaseReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; search_query?: string }) {
    const response = await apiClient.get("/reports/warehouse/purchase/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async exportWarehouseQuotationReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; search_query?: string }) {
    const response = await apiClient.get("/reports/warehouse/quotation/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async exportWarehouseReturnReport(params: { warehouse_id: string; from_date?: string; to_date?: string }) {
    // Placeholder - endpoint needs to be implemented
    const response = await apiClient.get("/reports/warehouse/return/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },

  async exportWarehouseExpenseReport(params: { warehouse_id?: string | number; from_date?: string; to_date?: string; search_query?: string }) {
    const response = await apiClient.get("/reports/warehouse/expense/export", {
      params,
      responseType: 'blob',
    });
    return response;
  },
};

export default reportService;
